import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";
import { baseURL } from "../../services/axios/eps";

const CategoryDetails = ({
  selectedCategory,
  setSelectedCategory,
  openDetailsModal,
  setOpenDetailsModal,
}) => {
  const handleCloseDetailsModal = () => {
    setSelectedCategory(null);
    setOpenDetailsModal(false);
  };

  return (
    <Modal
      show={openDetailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Game Category</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <div className="d-flex justify-content-center">
          {selectedCategory?.image && (
            <img
              crossorigin="anonymous"
              src={`${baseURL}/uploads/file/${selectedCategory.image}`}
              alt="Logo"
              className="img-fluid rounded center"
              style={{ maxHeight: "200px", objectFit: "contain" }}
            />
          )}
        </div>
        <Row className="mb-3">
          {Object.entries({
            Name: selectedCategory?.name || "",
            Status: selectedCategory?.status ? "Active" : "In-Active",
            "Created At": selectedCategory?.createdAt
              ? format(selectedCategory?.createdAt, "PP")
              : "",
            "Updated At": selectedCategory?.updatedAt
              ? format(selectedCategory?.updatedAt, "PP")
              : "",
            "Deleted At": selectedCategory?.deletedAt
              ? format(selectedCategory?.deletedAt, "PP")
              : "",
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span
                  className={`d-block fs-5 fw-medium ${!value && "text-danger"}`}
                >
                  {value || "N/A"}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default CategoryDetails;
